export default {"src":"/_next/static/media/video-icon.222f493d.svg","height":72,"width":72};